import { EmptyState, EmptyStateIcons, Icons } from '@silverfort/sf-components';
import { useMemo } from 'react';
import { EmptyStateProps } from '@silverfort/sf-components/dist/EmptyState';
import { SmallEmptyStateSection } from '../../../SmallEmptyStateSection';

export const useEmptyState = (
    hasFilterApplied: boolean,
    onCreateApplicationClick: () => void,
    onUploadApplicationClick: () => void
) => {
    return useMemo<EmptyStateProps | Array<EmptyStateProps>>(() => {
        if (hasFilterApplied) {
            return {
                className: 'w-full',
                description: 'Try to change your filter or create a new application.',
                icon: EmptyStateIcons.NoItems,
                title: 'There are no applications that match your filter'
            };
        }

        return [
            {
                children: (
                    <section className="flex gap-4 w-full">
                        <EmptyState
                            actionText="Create a new application"
                            className="w-2/3 border border-gray-100 rounded-lg"
                            description="Create a custom application from scratch"
                            icon={EmptyStateIcons.NoItems}
                            iconClassName="text-sf-gray-400"
                            iconSize={102}
                            onActionClick={onCreateApplicationClick}
                            title="Blank Application"
                        />

                        <div className="flex flex-col gap-4 w-1/3">
                            <SmallEmptyStateSection
                                action={{
                                    onClick: onUploadApplicationClick,
                                    label: 'Upload'
                                }}
                                description="Use our template to configure applications and upload quicly to Silverfort"
                                icon={Icons.CloudUpload}
                                title="Upload CSV"
                            />

                            <SmallEmptyStateSection
                                description="Contact your Silverfort representative to integrate with your CMDB solution"
                                icon={Icons.Sync}
                                title="Import Application"
                            />
                        </div>
                    </section>
                ),
                contentClassName: 'hidden',
                className: 'border-0 -mx-8 -my-2',
                title: ''
            }
        ];
    }, [hasFilterApplied, onCreateApplicationClick, onUploadApplicationClick]);
};
